module.exports = __webpack_public_path__ + "img/trip-start.7ae9b52e.svg";